module.exports = __webpack_public_path__ + "static/img/caijingshangmao-2.762ec9ec.svg";